import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { SideMenuService } from "app/modules/menus/services/sideMenu.service";
import { MenuItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { AuthModel } from "@nousmedis/nm-guard-auth";
import { UserService } from "app/modules/user/services/user.service";
import { User } from "@nousmedis/guard-types/dist/frontend";
import { Router } from "@angular/router";

@Component({
    selector: "nm-side-menu",
    templateUrl: "./side-menu.component.html",
    styleUrls: ["./side-menu.component.scss"],
})
export class SideMenuComponent implements OnInit {
    items: MenuItem[] = [];
    expanded: boolean = false;
    expanded$: Subscription;
    @Output() isExpanded = new EventEmitter<boolean>();
    loadItems: boolean = false;
    roleCode: string;
    user: User;

    constructor (
        private sideMenuService: SideMenuService,
        private translateService: TranslateService,
        private auth: AuthModel,
        private router: Router,
        private userService: UserService
    ) {
        this.roleCode = this.auth.getRoleCode();
    }

    async ngOnInit(): Promise<void> {
        this.user = this.auth.getCurrentUser();
        this.lookForExpansion();
        await this.setItems();
    }

    lookForExpansion() {
        this.expanded$ = this.sideMenuService.isExpanded.subscribe(
            (expansion) => { this.expanded = expansion; }
        );
    }

    logout() {
        this.auth.logOut(this.user);
        this.userService.user$.next(undefined);
        this.router.navigate(["/login"]);
    }

    async setItems() {
        this.items = [
            { title: "Inicio", icon: "pi pi-home", label: "Inicio", routerLink: "/" },
        ];
        this.loadItems = true;
    }
}
